import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap'; // Import Button component from react-bootstrap
import Styles from './contactus.module.scss';
import contactusImage from '../../assets/contactus.webp'; // Import the image using require

const ContactUs = () => {
  const navigate = useNavigate();
  const navigateToContactUs = () => {
		navigate('/contact');
	}
  return (
    <div className={Styles.informationSec}>
      <div className={Styles.image}>
        <img className={Styles.informationSecImage} src={contactusImage} alt="Health" />
      </div>
      <div className={Styles.textContainer}>
        <div className={Styles.informationSecText}>
          <h1>Contact Us</h1>
          <p>
          We'd love to hear from you! Whether you have a question, feedback, or just want to say hello, feel free to reach out. Our team is here to assist you.
          </p>
          <div onClick={navigateToContactUs}>
            <Button variant="secondary" className={Styles.informationSecButton}>
              Read More
            </Button>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export { ContactUs };